(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3LoginToolbar', {
            templateUrl: 'app/shared/navigation-bar/login-toolbar.component.html',
            controller: LoginToolbarComponent
        });

    LoginToolbarComponent.$inject = ['user', 'culture', 'signInManager'];
    function LoginToolbarComponent(user, culture, signInManager) {
        var ctrl = this;
        ctrl.user = user;
        Object.defineProperty(ctrl, 'culture', { get: getCulture, set: setCulture });
        ctrl.toggleLogin = toggleLogin;

        //////////////////////////////////////

        function toggleLogin() {
            signInManager.signOut();
        }

        function getCulture() {
            return culture.get();
        }
        function setCulture(value) {
            return culture.set(value);
        }
    }
})();
